import React from 'react';

import usePage from '@dashboard/hooks/usePage';
import { Form } from '@dashboard/components/Formik';

import useProduct from '../../PageProduct/useProduct';

export default function LimitSubscriptionsForm() {
  const { page, updatePage } = usePage();
  const { product } = useProduct();

  return (
    <Form
      initialValues={{
        limitSubscriptions: {
          enabled: page.limitSubscriptions?.enabled,
        },
        limitSubscriptionsStripe: {
          enabled: page.limitSubscriptionsStripe?.enabled,
        },
      }}
      fields={({ values }) => [
        ...(!product.planManagedInStripe
          ? [
              {
                name: 'limitSubscriptions.enabled',
                required: false,
                type: 'checkbox',
                label: 'Prevent duplicate subscriptions via this checkout',
                reduceMargin: values.limitSubscriptions?.enabled,
                tooltip: `Enable this setting to prevent people from starting multiple subscriptions on this checkout`,
              },
            ]
          : []),
        ...(product.planManagedInStripe
          ? [
              {
                name: 'limitSubscriptionsStripe.enabled',
                required: false,
                type: 'checkbox',
                label: 'Prevent duplicate subscriptions to this Stripe price via this checkout',
                tooltip: `Enable this setting on each checkout you’re selling this Stripe plan, to prevent people from starting multiple subscriptions to this plan.`,
              },
            ]
          : []),
      ]}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.resetForm({
            values: {
              limitSubscriptions: data.limitSubscriptions,
              limitSubscriptionsStripe: data.limitSubscriptionsStripe,
            },
          });
        }

        return {
          data,
          error,
        };
      }}
    />
  );
}
